import { render, staticRenderFns } from "./EditProvenance.vue?vue&type=template&id=15be460a&"
import script from "./EditProvenance.vue?vue&type=script&lang=js&"
export * from "./EditProvenance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports